import React from "react";
import styles from "./chat.module.scss";

const TypingIndicator = ({ sender }) => {
  return (
    <div className={styles.typing}>
      {sender && <span className={styles.sender}>{`${sender} is typing`}</span>}
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
      <span className={styles.dot}></span>
    </div>
  );
};

export default TypingIndicator;
